import jsonLd from './functions/_jsonLd'
import blogArticleList from './functions/blogArticleList'

export default function JsonLdBlogArticleList ({ articles, title }) {
    return articles
        ? jsonLd(blogArticleList(articles, title))
        : null
}